const initialState = {
    webhooks: [],
    loading: false,
    success: false,
    error: null,
  };
  
  const webHookReducer = (state = initialState, action) => {
    switch (action.type) {
      case "GET_ALL_WEBHOOKS":
        return {
          ...state,
          webhooks: action.payload,
        };
      case 'WEBHOOK_CREATE_SUCCESS':
          return {
              ...state,
              loading: false,
              success: true,
              error: null
          }
      case 'WEBHOOK_CREATE_FAIL':
          return {
              ...state,
              loading: false,
              success: false,
              error: true
          }
      case "WEBHOOK_UPDATE_SUCCESS":
        return { 
            ...state,
            loading: false,
            success: true,
            error: null
         };
  
      case "DELETE_WEBHOOK":
        return {
          ...state,
          webhooks: state.webhooks.filter(webhook => webhook._id !== action.payload),
        }
      default:
        return state;
    }
  };
  
  export default webHookReducer;
  